import CoachingForm from "../../components/CoachingForm/CoachingForm";
const CreateCoaching = () => {

    return (
        <div style={{ marginTop: '3%' }}>
            <CoachingForm type="Add" />
        </div>
    )
}
export default CreateCoaching;